import { atom } from "jotai";

export interface IZoneGroup {
    id?: number;
    name: string;
    description?: string | null;
    width?: number | null;
    height?: number | null;
    length?: number | null;
    x?: number | null;
    y?: number | null;
    z?: number | null;
    warehouse_id?: number | null;
    created_at?: string;
    updated_at?: string;
}

export interface IZoneGroupInput extends Omit<IZoneGroup, 'id' | 'created_at' | 'updated_at'> {}

export const zoneGroupsAtom = atom<IZoneGroup[]>([]);
export const zoneGroupsLoadingAtom = atom<boolean>(false);

